import actionTypes from './action-types';
import initialState from './initial-state';

// The max size of the item cache * before adding new items *
const ITEM_CACHE_MAX_SIZE = 500;
const RECENTLY_VIEWED_MAX_LENGTH = 4;

export default (state = initialState(), action) => {
    const add = () => {
        const { cache, cacheOrder } = state;
        // Clear out old items
        let newCache = {};
        let newCacheOrder = cacheOrder;
        if (cacheOrder.length > ITEM_CACHE_MAX_SIZE) {
            newCacheOrder = cacheOrder.slice(
                cacheOrder.length - ITEM_CACHE_MAX_SIZE
            );
            newCacheOrder.forEach(itemId => {
                newCache[itemId] = cache[itemId];
            });
        } else {
            newCache = cache;
        }
        // Add new items
        action.payload.forEach(item => {
            if (item.itemId in newCache) {
                // Combine existing item with updated item
                newCache[item.itemId] = {
                    ...newCache[item.itemId],
                    ...item
                };
                // Renew item in cache order
                newCacheOrder = [
                    ...newCacheOrder.filter(itemId => itemId !== item.itemId),
                    item.itemId
                ];
            } else {
                newCache[item.itemId] = item;
                newCacheOrder.push(item.itemId);
            }
        });

        return {
            ...state,
            cache: {
                ...newCache
            },
            cacheOrder: newCacheOrder
        };
    };

    const addRecentlyViewed = () => {
        const { payload: item } = action;
        const { recent } = state;
        // Remove item if already present
        let updatedRecent = recent.filter(
            recentItem => recentItem.itemId !== item.itemId
        );
        // Add to front of list
        updatedRecent.unshift(item);
        // Limit list length
        updatedRecent = updatedRecent.slice(0, RECENTLY_VIEWED_MAX_LENGTH);
        return {
            ...state,
            recent: updatedRecent
        };
    };

    const wishlist = () => {
        const {
            payload: { itemId, exists }
        } = action;
        return {
            ...state,
            cache: {
                ...state.cache,
                [itemId]: {
                    ...state.cache[itemId],
                    existsInWishList: exists
                }
            }
        };
    };

    const updateItem = () => {
        const {
            payload: { itemId, item }
        } = action;
        return {
            ...state,
            cache: {
                ...state.cache,
                [itemId]: {
                    ...state.cache[itemId],
                    ...item
                }
            }
        };
    };

    const def = () => state;

    const reducers = {
        [actionTypes.ADD]: add,
        [actionTypes.ADD_RECENTLY_VIEWED]: addRecentlyViewed,
        [actionTypes.WISHLIST]: wishlist,
        [actionTypes.UPDATE_ITEM]: updateItem
    };

    return !action || !action.type || !reducers[action.type]
        ? def()
        : reducers[action.type]();
};
